import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { Avatar, AvatarBadge, AvatarFallback, AvatarImage } from '@mdvip/shared/components/ui/avatar';
import { initials } from '@mdvip/shared/lib/initials';
import { useTranslation } from 'react-i18next';

export interface ProfileAvatarProps {
  firstName: string | null;
  lastName: string | null;
  photoUrl: string | null;
  /** Opens the update-photo dialog. Dialog state and Save wiring live one level up in
   * ProfilePage, matching the existing onEdit/EditProfileDialog pattern — this component is
   * purely the avatar + its one entry point into that flow. */
  onEditPhoto: () => void;
}

/**
 * The member's photo — or initials on the brand gradient, with none set — with a camera-badge
 * trigger for opening the update-photo dialog.
 */
export function ProfileAvatar({ firstName, lastName, photoUrl, onEditPhoto }: ProfileAvatarProps) {
  const { t } = useTranslation('members');
  const editLabel = t(photoUrl ? 'profile.photo.updateLabel' : 'profile.photo.addLabel');

  return (
    <Avatar className="size-14">
      {photoUrl ? <AvatarImage src={photoUrl} alt="" /> : null}
      <AvatarFallback className="bg-gradient-to-br from-avatar-gradient-from to-avatar-gradient-to text-sm font-semibold text-foreground">
        {initials({ firstName, lastName })}
      </AvatarFallback>
      <AvatarBadge aria-label={editLabel} onClick={onEditPhoto}>
        <Icon name="camera" size="xs" />
      </AvatarBadge>
    </Avatar>
  );
}
